<script setup>
import axios from 'axios';
import { computed } from 'vue';

const emits = defineEmits(['error']);

const props = defineProps({
  iid: {
    type: String,
    required: true,
  },
  reviewers: {
    type: Array,
    required: true,
  },
  projectId: {
    type: String,
    required: true,
  },
  suggestedReviewer: {
    type: String,
    required: true,
  },
  webUrl: {
    type: String,
    required: true,
  },
});

const showSuggestedReviewer = computed(
  () => !props.reviewers.some(reviewer => reviewer.toLowerCase() === props.suggestedReviewer.toLowerCase()),
);

const requestHelp = async (reviewer) => {
  const response = await axios.post(
    '/api/v1/manage_merge_request/help',
    {
      merge_request_iid: props.iid,
      project_id: props.projectId,
      reviewer,
    },
  );

  if (response?.status === 200) {
    window.location.href = props.webUrl;
  } else {
    emits('error');
  }
};
</script>

<template>
  <div
    v-for="reviewer in reviewers"
    :key="reviewer"
  >
    <a
      href="#"
      @click.stop="requestHelp(reviewer)"
    >Request help from current reviewer {{ reviewer }}</a>.
  </div>
  <div v-if="showSuggestedReviewer">
    <a
      href="#"
      @click.stop="requestHelp(suggestedReviewer)"
    >Request help from suggested reviewer {{ suggestedReviewer }}</a>.
  </div>
</template>
